<template>
  <div>    
    <v-row style="margin:2px">
        <v-spacer />
        <v-card outlined flat>
          <v-card-title>
            Registrácia
          </v-card-title>          
          <v-card-text>            
            <p style="color:green;text-align:left;margin-bottom:5px">Súčasní študenti sú registrovaní automaticky. Pre získanie hesla použite <v-chip style="cursor:pointer" @click="lostPwd()">Zabudnuté heslo</v-chip></p>
            <p></p>
            <p v-if="feedback" style="color: red">{{feedback}}</p>
            <p></p>
            <v-text-field variant="outlined" label="Tituly pred:" v-model="ttl_pred"></v-text-field>
            <v-text-field variant="outlined" label="Meno:" v-model="meno"></v-text-field>
            <v-text-field variant="outlined" label="Priezvisko:" v-model="priezvisko"></v-text-field>
            <v-text-field variant="outlined" label="Nickname (viditeľné spolužiakmi a verejnosťou):" v-model="nickname"></v-text-field>
            <v-text-field variant="outlined" label="Tituly za:" v-model="ttl_za"></v-text-field>
            <v-text-field
              variant="outlined"
              label="E-mail:"
              v-model="email"
              :rules="emailrules"
              ></v-text-field>

            <v-text-field label="Heslo:" v-model="heslo" variant="outlined"
              :append-icon="show1 ? 'visibility_off' : 'visibility'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              ></v-text-field>
            <v-row>
                <p style="color:red;text-align:left" v-if="getFeedback">{{getFeedback}}</p>
                <v-checkbox v-model="agree" label="Súhlasím s podmienkami spracúvania osobných údajov" />
                <v-spacer />
                <v-btn @click="odosliData()" :disabled="!agree">Registrovať</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
        <v-spacer />
    </v-row>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    data () {
      return {
        feedback: '', 
        ttl_pred : '',
        meno: '',
        priezvisko : '',
        nickname : '',
        ttl_za: '',
        email: '',
        heslo: '',
        show1 : false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },
        emailrules: [
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }],
          agree: false
      }
    },
  computed: mapGetters([
            'getFeedback'
        ]),
    methods: {
      odosliData () {
        this.feedback = null
        if (this.meno.length < 2) { 
          this.feedback = "Meno je príliš krátke." 
          return 
        }
        if (this.priezvisko.length < 2) {
          this.feedback = "Priezvisko je príliš krátke."
          return
        }

        if (this.nickname.length < 2) {
          this.feedback = "Nickname je príliš krátke."
          return
        }

        if (this.email.length < 2) {
          this.feedback = "E-mail je príliš krátky."
          return
        }          

        const formData = {
          ttl_pred : this.ttl_pred,
          meno: this.meno,
          priezvisko : this.priezvisko,
          ttl_za: this.ttl_za,
          nickname : this.nickname,
          email: this.email,
          heslo: this.heslo
        }
        this.$store.dispatch('register', formData)
      },
      lostPwd(){
        this.$router.push({name:'login', params: {}})
      }
    }
  }
</script>

<style >

</style>
